"use strict";

exports.__esModule = true;
var _TicketGrid = require("./TicketGrid");
Object.keys(_TicketGrid).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TicketGrid[key]) return;
  exports[key] = _TicketGrid[key];
});